import { api, bareApi, type SessionResponse } from './http';
import type { ClubMemberRole } from './users';

export const registerClubRequest = (data: {
  club_name: string;
  name: string;
  login: string;
  password: string;
  is_pilot?: boolean;
}) =>
  bareApi.post<SessionResponse>('/clubs/register', data).then((res) => res.data);

export type UserClub = {
  club_id: number;
  club_name: string;
  role: string;
  active: boolean;
};

export const fetchMyClubs = () =>
  api.get<UserClub[]>('/clubs/mine').then((res) => res.data);

export const switchClubRequest = (club_id: number) =>
  api.put<SessionResponse>('/clubs/active', { club_id }).then((res) => res.data);

export const createAdditionalClubRequest = (
  club_name: string,
  is_pilot: boolean = true
) =>
  api
    .post<SessionResponse>('/clubs', { club_name, is_pilot })
    .then((res) => res.data);

export const updateClubNameRequest = (club_name: string) =>
  api
    .put<{ updated: boolean; club_id: number; club_name: string }>('/clubs', {
      club_name,
    })
    .then((res) => res.data);

export const acceptInviteRequest = (data: {
  token: string;
  name?: string;
  login?: string;
  password?: string;
}) =>
  // bare для гостя; с cookies/Bearer — api, чтобы подтянуть текущего пользователя
  (data.name && data.login && data.password
    ? bareApi
    : api
  )
    .post<SessionResponse>('/clubs/invites/accept', {
      token: data.token,
      name: data.name || '',
      login: data.login || '',
      password: data.password || '',
    })
    .then((res) => res.data);

export const createClubInvite = (data?: {
  role?: ClubMemberRole;
  days?: number;
}) =>
  api.post<{ token: string; role: string; expires_at?: string; created: boolean }>(
    '/clubs/invites',
    data || { role: 'pilot', days: 14 }
  );
